import React from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import useFormContext from "./ResponsiveEvent.jsx/useFormContext";
import Modal from './SendforValidationModal';
import { CANCEL_EVENT } from './ApiDetails.js';
import { confirm } from '../utilities/Confirm.tsx';

export default function Footer() {
  const {
    eventFormData,
    handleDeleteDraft,
    handleSendForValidation,
    handleSubmit,
    showModal,
    closeModal,
  } = useFormContext();

  const navigate = useNavigate();

  const navigateToApp = (role) => {
    // Role-based redirection
    switch (role) {
      case 'Visit Requester':
      case 'Requester':
        navigate('/AppRequester');
        break;
      case 'Admin':
        navigate('/AppAdmin');
        break;
      case 'Family':
        navigate('/AppFamily');
        break;
      case 'MLTUser':
        navigate('/AppMltEvent');
        break;
      case 'FamilyCoordinator':
        navigate('/AppFamily');
        break;
      case 'MLTCoordinator':
        navigate('/AppMltEvent');
        break;
      default:
        navigate('/');  // Redirect to home or login in case of an invalid role
        break;
    }
  }

  const handleCancelEvent = async () => {
    const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to cancel this event?' });
    if (confirmResult) {
      try {
        const response = await axios.post(
          `${CANCEL_EVENT}/${eventFormData.eventId}`,
          {}, // An empty object as a placeholder for the request body if needed
          {
            headers: {
              'Content-Type': 'application/json', // Adjust if the API needs different headers
            },
          }
        );
        if (response.status === 200) {
          alert("Event has been canceled successfully.");
          navigateToApp(localStorage.getItem('role'));
        } else {
          console.error("Failed to cancel the event. Response:", response);
          alert("Failed to cancel the event. Please try again.");
        }
      } catch (error) {
        console.error("Error canceling the event:", error.response || error.message);
        alert(`An error occurred while canceling the event: ${error.response?.data || error.message}`);
      }
    }
  };

  const handleBackclick = () => {
    navigate(-1)
  }

  // Conditionally render buttons based on event status
  const renderButtons = () => {
    // If status is 'Under review', show only the "Cancel Event" button
    if (eventFormData.eventStatus === 'Under review') {
      return (
        <button
          type="button"
          id="cancelEvent"
          className="btn btn-outline-light right-buttons"
          onClick={handleCancelEvent}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="white" />
            <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="white" />
            <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="white" />
          </svg>
          CANCEL EVENT
        </button>
      );
    }



    // For all other statuses
    return (
      <>
            {((eventFormData.eventStatus === 'Draft') || (eventFormData.eventStatus === 'Under review')) && (
              <button
                type="button"
                id="deleteDraft"
                className="btn btn-outline-light right-buttons footerButtons"
                onClick={handleDeleteDraft}
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.7377 2.56289C6.66895 1.94414 6.15332 1.46289 5.5002 1.46289C4.84707 1.46289 4.33145 1.94414 4.2627 2.56289L1.68457 2.56289L1.68457 3.31914H2.44082L2.44082 10.1941C2.44082 10.4004 2.6127 10.5723 2.81895 10.5723L8.18145 10.5723C8.3877 10.5723 8.55957 10.4004 8.55957 10.1941L8.55957 3.31914L9.31582 3.31914V2.56289L6.7377 2.56289ZM5.5002 2.15039C5.74082 2.15039 5.98145 2.32227 6.0502 2.56289L4.98457 2.56289C5.01895 2.32227 5.25957 2.15039 5.5002 2.15039ZM7.80332 9.81602L3.19707 9.81602L3.19707 3.31914L7.76895 3.31914L7.76895 9.81602H7.80332Z" fill="white" />
                  <path d="M5.12148 4.0752H4.36523L4.36523 9.0252H5.12148L5.12148 4.0752Z" fill="white" />
                  <path d="M6.63418 4.0752H5.87793L5.87793 9.0252H6.63418L6.63418 4.0752Z" fill="white" />
                </svg>
                <span>DELETE DRAFT</span>
              </button>
            )}

            <button
              id="saveChanges"
              className="btn btn-outline-light right-buttons footerButtons"
              onClick={handleSubmit}
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.83254 1.53125L1.83254 7.63341L9.16746 7.63341L9.16746 3.45388L8.04612 2.33254H6.57866L6.57866 4.36659L2.72629 4.36659L2.72629 2.33254H1.83254L1.83254 1.53125ZM1.83254 1.53125L8.37802 1.53125L9.96875 3.12198L9.96875 9.66746C9.96875 10.11 9.61 10.4688 9.16746 10.4688L1.83254 10.4688C1.39 10.4688 1.03125 10.11 1.03125 9.66746L1.03125 2.33254C1.03125 1.89 1.39 1.53125 1.83254 1.53125ZM3.52759 2.33254L3.52759 3.5653L5.77737 3.5653V2.33254L3.52759 2.33254ZM9.16746 8.4347H1.83254L1.83254 9.66746L9.16746 9.66746V8.4347Z" fill="white" />
              </svg>
              <span>SAVE CHANGES</span>
            </button>

            {(eventFormData.eventStatus === 'Draft') && (
              <button
                type="button"
                id="sendValidation"
                className="buttonrequest btn btn-outline-light right-buttons footerButtons"
                onClick={handleSendForValidation}
              >
                <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z" fill="currentColor" />
                </svg>
                <span>{eventFormData.mltEvent ? 'VALIDATE AND OPEN EVENT' : 'SEND FOR VALIDATION'}</span>
              </button>
            )}
      </>
    );
  };

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row footerButtonsContainer">
          <div className="col-md-6">
            <button
              type="button"
              id="backBtn"
              className="btn btn-outline-light left-button"
              onClick={handleBackclick}

            >
              Back
            </button>
          </div>
          <div className="col-md-6 text-end">
            {renderButtons()}
          </div>
        </div>
      </div>
      <Modal show={showModal} handleClose={closeModal}>
        <p>
          {eventFormData.mltEvent
            ? 'Your Request is moved to Open Event.'
            : 'Your Request is now Under Review.'}
        </p>

      </Modal>
    </footer>
  );
}
